import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	PetitionPreviewLinkByIdQuery,
	PetitionPreviewLinkByIdQueryVariables,
} from './getPetitionPreviewLinkById.graphql';
import { PetitionPreviewLinkById } from './getPetitionPreviewLinkById.graphql';

export type FilterKey = PetitionPreviewLinkByIdQueryVariables['filterKey'];
export type PreviewLinkResult = PetitionPreviewLinkByIdQuery['getPetitionPreviewLinks'];
export type PreviewLink = PreviewLinkResult['items'][number];

export async function getPreviewLinkById(
	slug: string,
	{ gql: { fetch } }: UtilityContext,
	previewLinkId: string,
): Promise<PreviewLink | undefined> {
	const { data } = await fetch<PetitionPreviewLinkByIdQuery, PetitionPreviewLinkByIdQueryVariables>({
		query: PetitionPreviewLinkById,
		variables: { slug, filterKey: 'PREVIEW_ID', filterValue: previewLinkId },
		rejectOnError: true,
	});

	if (data.getPetitionPreviewLinks.totalCount === 0) {
		return undefined;
	}
	return data.getPetitionPreviewLinks.items[0];
}
